import { render } from "./CategoryPage.vue?vue&type=template&id=747bba2e&scoped=true"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"

import "./CategoryPage.vue?vue&type=style&index=0&id=747bba2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747bba2e"]])

export default __exports__